<template>
  <Modal ref="modal" :title="title">
    <form class="export-container" @submit.prevent="handleSubmit">
      <Period v-if="type === 'full'" legend="Insira o período" :firstModelValue="initialDate"
        :secondModelValue="finalDate" @update:firstModelValue="$event => (this.initialDate = $event)"
        @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />

      <div class="format-container">
        <span>Em qual formato de exportação?</span>

        <RadioButtons :options="radioOptions" name="format" :modelValue="format"
          @update:modelValue="$event => this.format = $event" />
      </div>

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Button from '../core/Button.vue'
import Modal from '../core/Modal.vue'
import Period from '../core/Period.vue'
import TrayArrowDown from 'icons/TrayArrowDown'
import RadioButtons from '../core/RadioButtons.vue'

export default {
  name: 'ExportModal',
  components: {
    Modal,
    Button,
    TrayArrowDown,
    Period,
    RadioButtons,
  },
  props: {
    title: {
      type: String,
      default: 'Exportar',
    },
    type: {
      type: String,
      default: 'full',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      radioOptions: [
        { value: "pdf", label: "PDF", info: "(Documento)" },
        { value: "csv", label: "CSV", info: "(Planilha)" },
        { value: "txt", label: "TXT", info: "(Texto sem formatação)", disabled: true },
      ],
      initialDate: '',
      finalDate: '',
      format: 'pdf',
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.initialDate = ''
      this.finalDate = ''
      this.format = 'pdf'
      this.$refs.modal.close()
    },
    async handleSubmit() {
      if (this.type === 'full' && !this.validateInputs()) {
        return
      }

      const params = {
        format: this.format,
      }

      if (this.type === 'full') {
        params.initialDate = this.initialDate
        params.finalDate = this.finalDate
      }

      this.$emit("submit:export", params)
    },
    validateInputs() {
      if (!this.initialDate || !this.finalDate) {
        this.toast('Os campos de período são obrigatórios.')
        return false
      }

      const initial = new Date(this.initialDate)
      const final = new Date(this.finalDate)

      if (final < initial) {
        this.toast('A data final deve ser menor que a data inicial!')
        return false
      }

      return true
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>